import { Box, BoxProps, Text, TextProps } from '@chakra-ui/react';

import { SERVICE_CARD_BORDER_RADIUS } from 'components';

const sectionBorder = 'rgba(255,255,255,0.08)';

const BorderedBox: React.FC<
  {
    children: React.ReactNode;
    title: string;
    titleProps?: TextProps;
  } & BoxProps
> = ({
  title,
  children,
  titleProps,
  ...props
}: {
  title: string;
  children: React.ReactNode;
  titleProps?: TextProps;
} & BoxProps) => {
  return (
    <Box
      bg="dark"
      borderRadius={SERVICE_CARD_BORDER_RADIUS}
      borderWidth="1px"
      borderColor={sectionBorder}
      p={{ base: 5, md: 6 }}
      w={{ base: '100%', xl: '50%' }}
      minW={0}
      {...props}
    >
      <Text
        fontSize="md"
        fontWeight="semibold"
        color="body"
        pb={3}
        mb={4}
        borderBottomWidth="1px"
        borderBottomColor={sectionBorder}
        {...titleProps}
      >
        {title}
      </Text>
      {children}
    </Box>
  );
};
export default BorderedBox;
